"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var real = exports.real = [0, 0.8, 0.6, 0.6, 0.7, 0.6, 0, 0.8, 0.3, 1];

var imag = exports.imag = real.map(function () {
  return 0;
});